import { RouteObject, UIMatch } from "react-router";

import { CurrentClientName } from "@components/Texts";

import { ExtensionInstallationGuard } from "@components/RouteGuards/ExtensionInstallationGuard/ExtensionInstallationGuard";

import { routes } from "@pages/routes";

import { ApplicationUsageByUsers } from "./ApplicationUsageByUsers/ApplicationUsageByUsers.page";
import { Client } from "./Client/Client.page";
import { ClientDashboard } from "./ClientDashboard/ClientDashboard.page";
import { ClientNotificationHistory } from "./ClientNotificationHistory/ClientNotificationHistory.page";
import { ClientNotifications } from "./ClientNotifications/ClientNotifications.page";
import { ClientNotificationsLayout } from "./ClientNotifications/ClientNotificationsLayout";
import { Clients } from "./Clients/Clients.page";
import { ColumnSettings } from "./ColumnSettings/ColumnSettings.page";
import { CreateClient } from "./CreateClient/CreateClient.page";
import { ExtensionInstallation } from "./ExtensionInstallation/ExtensionInstallation.page";

export const clientRoutes = [
  {
    path: routes.portal.clients.$path(),
    Component: Clients,
    handle: { fullBleed: true },
    children: [
      {
        path: routes.portal.clients.columnSettings.$path(),
        Component: ColumnSettings,
      },
    ],
  },
  {
    path: routes.portal.clients.create.$path(),
    Component: CreateClient,
    handle: {
      breadcrumb: {
        title: "Create",
      },
    },
  },
  {
    path: routes.portal.clients.client.$path(),
    Component: ExtensionInstallationGuard,
    handle: {
      breadcrumb: ({ params }: UIMatch) => ({
        reset: true,
        title: <CurrentClientName />,
        path: routes.portal.clients.client.dashboard.$buildPath({
          params: { clientId: params.clientId as string },
        }),
      }),
    },
    children: [
      {
        path: routes.portal.clients.client.record.$path(),
        Component: Client,
        handle: {
          breadcrumb: {
            title: "Record",
          },
        },
      },
      {
        path: routes.portal.clients.client.dashboard.$path(),
        Component: ClientDashboard,
        handle: {
          breadcrumb: {
            title: "Dashboard",
          },
        },
        children: [
          {
            path: routes.portal.clients.client.dashboard.applicationUsageByUsers.$path(),
            Component: ApplicationUsageByUsers,
          },
        ],
      },
      {
        path: routes.portal.clients.client.extension.$path(),
        Component: ExtensionInstallation,
        handle: {
          breadcrumb: {
            title: "Extension",
          },
        },
      },
      {
        path: routes.portal.clients.client.notifications.$path(),
        Component: ClientNotificationsLayout,
        handle: {
          fullBleed: true,
          breadcrumb: {
            title: "Notifications",
          },
        },
        children: [
          {
            index: true,
            Component: ClientNotifications,
            handle: {
              fullBleed: true,
            },
          },
          {
            path: routes.portal.clients.client.notifications.history.$path(),
            Component: ClientNotificationHistory,
            handle: {
              fullBleed: true,
              breadcrumb: {
                title: "History",
              },
            },
          },
        ],
      },
    ],
  }
] satisfies RouteObject[];
